'use strict';

var React = require('react');

var SvgJobsMajor = function SvgJobsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.508 2.466-1.152 2.534h-1.856a1.5 1.5 0 0 0-1.5 1.5v1.882l.503.251a19 19 0 0 0 16.994 0l.503-.251v-1.882a1.5 1.5 0 0 0-1.5-1.5h-1.856l-1.152-2.534a2.5 2.5 0 0 0-2.276-1.466h-4.432a2.5 2.5 0 0 0-2.276 1.466zm2.276.534a.5.5 0 0 0-.455.293l-.776 1.707h6.894l-.776-1.707a.5.5 0 0 0-.455-.293h-4.432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10.613a20.986 20.986 0 0 1-8 2.003v1.384a1 1 0 0 1-2 0v-1.384a20.995 20.995 0 0 1-8-2.003v6.887a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-6.887z"
  }));
};

exports.SvgJobsMajor = SvgJobsMajor;
